import { render, staticRenderFns } from "./DeletedRecordBadge.vue?vue&type=template&id=71a642f2&scoped=true"
import script from "./DeletedRecordBadge.vue?vue&type=script&lang=js"
export * from "./DeletedRecordBadge.vue?vue&type=script&lang=js"
import style0 from "./DeletedRecordBadge.vue?vue&type=style&index=0&id=71a642f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a642f2",
  null
  
)

export default component.exports